module.exports = __webpack_public_path__ + "img/sxtqk.9501ce8c.png";